import {
  CODE_ACTION_PLAN,
  SYSTEM_ACTION_PLAN,
  SYSTEM_LIFEOMIC_DATASET,
} from '../../../../util/fhir';

export const HEALTH_SUMMARY_AGENT = 'api-health-summary-agent';

export const hasActiveStandardCarePlan = (
  carePlans: fhir.CarePlan[] | undefined,
): boolean => carePlans?.some(plan => plan.status === 'active') ?? false;

export const hasDuplicateActiveStandardCarePlans = (
  carePlans: fhir.CarePlan[] | undefined,
): boolean =>
  (carePlans?.filter(plan => plan.status === 'active').length ?? 0) > 1;

export const hasOtherActiveStandardCarePlan = (
  carePlans: fhir.CarePlan[] | undefined,
  currentCarePlanId: string | undefined,
): boolean =>
  carePlans?.some(
    plan => plan.status === 'active' && plan.id !== currentCarePlanId,
  ) ?? false;

export const buildMinimalActionPlan = (
  patientId: string,
  projectId: string,
): fhir.CarePlan => ({
  resourceType: 'CarePlan',
  status: 'active',
  intent: 'plan',
  category: [
    {
      coding: [
        {
          system: SYSTEM_ACTION_PLAN,
          code: CODE_ACTION_PLAN,
        },
      ],
    },
  ],
  subject: { reference: `Patient/${patientId}` },
  meta: {
    tag: [
      { system: SYSTEM_LIFEOMIC_DATASET, code: projectId },
      {
        system: SYSTEM_ACTION_PLAN,
        code: CODE_ACTION_PLAN,
      },
    ],
  },
});
